import './utils/send-mixer-ping';
import '@zr/common/js/footer/_footer_light';

import { initEmailPopover } from './partials/_email-popover';

initEmailPopover();

// Set modal params.
if ($.modal) {
  $.modal.wait = 0;
  $.modal.zrsCloseBtn = true;
}

if (zr.page.model.isLoggedIn) {
  import('@zr/common/js/get-auto-banners');
}
